import { socket } from "@/api/client";
import { sdk } from "@/api/sdk";

/**
 * Binds the socket to the signed-in session.
 *
 * The upgrade request authenticates with the session cookie, and nothing on the socket path can
 * refresh that cookie: an HTTP request through the auth middleware rotates an expired access
 * token, a WebSocket handshake cannot. So before every connection attempt (first connect,
 * automatic reconnect, manual reconnect) we call `users/me` first. A signed-in user gets a fresh
 * cookie and the handshake goes through. A signed-out visitor gets a 401 and the attempt is
 * abandoned, instead of being refused with close code 4001 and retried every five seconds.
 *
 * Registered at import time, so the connect the socket makes on its own at startup already runs
 * through it. The (private) route guard imports this module and opens and closes the socket as
 * the signed-in area is entered and left.
 */
socket.onConnect(async ({ connection }) => {
  const { status } = await sdk.users.me.$get.send();
  if (status === 401 || status === 403) {
    throw new Error("Not signed in, leaving the socket closed");
  }
  return connection;
});

/** Opens the socket for the signed-in area. A no-op when it is already connected. */
export const connectSessionSocket = () => {
  void socket.connect();
};

/** Closes the socket when the signed-in area is left, so a signed-out tab stops receiving pushes. */
export const disconnectSessionSocket = () => {
  void socket.disconnect();
};
